module.exports = __webpack_public_path__ + "img/p1-desc.d7f1ebc5.jpg";